// block icon.
export const TableBlockIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" viewBox="0 0 512 512">
		<defs>
			<style>{ '.st1{fill:#f26c0d}' }</style>
		</defs>
		<path
			d="M123.1 177.9c12.6.2 25.2 0 37.8 0s25.2.1 37.8 0c15.1-.2 27.8-11.6 30-26.6 2.2-15.1-7-29.6-21.7-33.9-2.5-.7-3.3-1.7-3.8-4.3-2.7-15.8-15.5-27.8-31.7-30.1-15.2-2.1-30.7 6.1-37.8 20.3-.4.9-.8 1.1-1.8.8-13.6-3.4-26 9-22.4 22.4.3 1.2 0 1.6-.9 2.3-9.3 6.5-13.5 15.4-11.8 26.6 2 13.1 12.9 22.3 26.1 22.5ZM201 191.5l-10.6 10.6c-3 3-3 7.8 0 10.8 3 3 7.8 3 10.8 0l10.6-10.6c3-3 3-7.8 0-10.8s-7.8-3-10.8 0ZM162.7 191.5l-10.6 10.6c-3 3-3 7.8 0 10.8s7.8 3 10.8 0l10.6-10.6c3-3 3-7.8 0-10.8s-7.8-3-10.8 0ZM124.4 191.5l-10.6 10.6c-3 3-3 7.8 0 10.8 3 3 7.8 3 10.8 0l10.6-10.6c3-3 3-7.8 0-10.8s-7.8-3-10.8 0Z"
			className="st1"
		/>
		<rect
			width={ 155.2 }
			height={ 34.4 }
			x={ 260.3 }
			y={ 100.8 }
			className="st1"
			rx={ 17.2 }
			ry={ 17.2 }
		/>
		<rect
			width={ 62.7 }
			height={ 34.4 }
			x={ 260.3 }
			y={ 162.5 }
			className="st1"
			rx={ 17.2 }
			ry={ 17.2 }
		/>
		<rect
			width={ 81.4 }
			height={ 34.4 }
			x={ 334.1 }
			y={ 162.5 }
			className="st1"
			rx={ 17.2 }
			ry={ 17.2 }
		/>
		<path
			d="M448 1.5H64C29.5 1.5 1.5 29.5 1.5 64v384c0 34.5 28 62.5 62.5 62.5h384c34.5 0 62.5-28 62.5-62.5V64c0-34.5-28-62.5-62.5-62.5Zm-384 45h384c9.6 0 17.5 7.9 17.5 17.5v188h-419V64c0-9.6 7.9-17.5 17.5-17.5Zm137 313.2V297h110v62.7H201Zm110 45v60.8H201v-60.8h110Zm-155-45H46.5V297H156v62.7ZM356 297h109.5v62.7H356V297ZM46.5 448v-43.3H156v60.8H64c-9.6 0-17.5-7.9-17.5-17.5ZM448 465.5h-92v-60.8h109.5V448c0 9.6-7.9 17.5-17.5 17.5Z"
			className="st1"
		/>
	</svg>
);
// preview image.
export const TablePreview = () => (
	<svg viewBox="0 0 236 158" fill="none" xmlns="http://www.w3.org/2000/svg">
		<rect
			x={ 0.75 }
			y={ 0.75 }
			width={ 234.5 }
			height={ 156.5 }
			rx={ 3.25 }
			fill="white"
		/>
		<rect
			x={ 0.75 }
			y={ 0.75 }
			width={ 234.5 }
			height={ 156.5 }
			rx={ 3.25 }
			stroke="#9EA9B2"
			strokeWidth={ 1.5 }
		/>
		<path
			d="M21.4077 20.8164H214.594V39.8629H21.4077V20.8164Z"
			fill="#DEE2E5"
		/>
		<path
			d="M207.7 81.8559V82.8559H28.2999V81.8559H207.7ZM214.5 75.0551V28.2553C214.5 26.3889 214.498 25.0896 214.366 24.1098C214.238 23.1587 214.005 22.6595 213.65 22.3051C213.296 21.9508 212.797 21.7172 211.846 21.5893C210.866 21.4576 209.567 21.4555 207.7 21.4555H28.2999C26.4335 21.4555 25.1342 21.4576 24.1544 21.5893C23.2032 21.7172 22.704 21.9508 22.3497 22.3051C21.9953 22.6595 21.7617 23.1587 21.6339 24.1098C21.5022 25.0896 21.5001 26.3889 21.5001 28.2553V75.0551C21.5001 76.9219 21.5021 78.2217 21.6339 79.2016C21.7617 80.1528 21.9953 80.6519 22.3497 81.0063C22.704 81.3606 23.2034 81.5943 24.1544 81.7221C25.1342 81.8538 26.4335 81.8559 28.2999 81.8559V82.8559L27.0049 82.853C24.2751 82.8379 22.7525 82.7216 21.751 81.8168L21.6426 81.7133C20.5004 80.571 20.5001 78.7321 20.5001 75.0551V28.2553C20.5001 24.6934 20.4996 22.8563 21.5381 21.7065L21.6426 21.5981C22.7849 20.4558 24.623 20.4555 28.2999 20.4555H207.7L208.995 20.4575C211.826 20.4731 213.358 20.5986 214.357 21.5981C215.5 22.7404 215.5 24.5785 215.5 28.2553V75.0551C215.5 78.7321 215.5 80.571 214.357 81.7133L214.249 81.8168C213.248 82.7216 211.725 82.8379 208.995 82.853L207.7 82.8559V81.8559C209.567 81.8559 210.866 81.8538 211.846 81.7221C212.797 81.5943 213.296 81.3606 213.65 81.0063C214.005 80.6519 214.238 80.1527 214.366 79.2016C214.498 78.2217 214.5 76.9219 214.5 75.0551Z"
			fill="#58707F"
		/>
		<path
			d="M152.599 81.6552V82.6552H102.4V81.6552H152.599ZM155.5 78.7549V43.3556C155.5 42.4081 155.497 41.7977 155.437 41.3488C155.381 40.9287 155.29 40.8024 155.221 40.7336C155.152 40.6648 155.026 40.5742 154.606 40.5177C154.157 40.4574 153.547 40.4552 152.599 40.4552H102.4C101.452 40.4552 100.842 40.4574 100.393 40.5177C99.973 40.5742 99.8467 40.6648 99.7779 40.7336C99.7091 40.8024 99.6185 40.9287 99.562 41.3488C99.5319 41.5733 99.5164 41.8381 99.5083 42.1652L99.4995 43.3556V78.7549C99.4995 79.7024 99.5017 80.3128 99.562 80.7617C99.6185 81.1816 99.7091 81.3081 99.7779 81.3769C99.8467 81.4457 99.9732 81.5363 100.393 81.5927C100.842 81.6531 101.452 81.6552 102.4 81.6552V82.6552L101.184 82.6465C100.212 82.6219 99.6063 82.5295 99.1822 82.1845L99.0708 82.084C98.4997 81.5128 98.4995 80.5933 98.4995 78.7549V43.3556C98.4995 41.6321 98.4997 40.7162 98.9702 40.1379L99.0708 40.0265C99.4992 39.5982 100.123 39.4908 101.184 39.464L102.4 39.4552H152.599C154.438 39.4552 155.357 39.4554 155.928 40.0265C156.499 40.5977 156.5 41.5171 156.5 43.3556V78.7549C156.5 80.5933 156.499 81.5128 155.928 82.084L155.817 82.1845C155.393 82.5295 154.787 82.6219 153.815 82.6465L152.599 82.6552V81.6552C153.547 81.6552 154.157 81.6531 154.606 81.5927C155.026 81.5363 155.152 81.4457 155.221 81.3769C155.29 81.3081 155.381 81.1816 155.437 80.7617C155.497 80.3128 155.5 79.7024 155.5 78.7549Z"
			fill="#58707F"
		/>
		<path
			d="M103.374 47.7447C103.374 46.6678 104.247 45.7947 105.324 45.7947C106.401 45.7947 107.274 46.6678 107.274 47.7447C107.274 48.8217 106.401 49.6947 105.324 49.6947C104.247 49.6947 103.374 48.8217 103.374 47.7447Z"
			fill="#58707F"
		/>
		<path
			d="M109.224 47.7447C109.224 46.937 109.879 46.2822 110.687 46.2822H123.362C124.17 46.2822 124.824 46.937 124.824 47.7447C124.824 48.5524 124.17 49.2072 123.362 49.2072H110.687C109.879 49.2072 109.224 48.5524 109.224 47.7447Z"
			fill="#58707F"
		/>
		<path
			d="M136.524 47.7447C136.524 46.937 137.179 46.2822 137.987 46.2822H150.662C151.47 46.2822 152.124 46.937 152.124 47.7447C152.124 48.5524 151.47 49.2072 150.662 49.2072H137.987C137.179 49.2072 136.524 48.5524 136.524 47.7447Z"
			fill="#58707F"
		/>
		<path
			d="M161.874 47.7447C161.874 46.6678 162.747 45.7947 163.824 45.7947C164.901 45.7947 165.774 46.6678 165.774 47.7447C165.774 48.8217 164.901 49.6947 163.824 49.6947C162.747 49.6947 161.874 48.8217 161.874 47.7447Z"
			fill="#58707F"
		/>
		<path
			d="M167.724 47.7447C167.724 46.937 168.379 46.2822 169.187 46.2822H181.862C182.67 46.2822 183.324 46.937 183.324 47.7447C183.324 48.5524 182.67 49.2072 181.862 49.2072H169.187C168.379 49.2072 167.724 48.5524 167.724 47.7447Z"
			fill="#58707F"
		/>
		<path
			d="M195.024 47.7447C195.024 46.937 195.679 46.2822 196.487 46.2822H209.162C209.97 46.2822 210.624 46.937 210.624 47.7447C210.624 48.5524 209.97 49.2072 209.162 49.2072H196.487C195.679 49.2072 195.024 48.5524 195.024 47.7447Z"
			fill="#58707F"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M98.4993 53.5945H214.499V54.5945H98.4993V53.5945Z"
			fill="#58707F"
		/>
		<path
			d="M102.466 62.5417C102.466 61.4647 103.339 60.5917 104.416 60.5917C105.492 60.5917 106.366 61.4647 106.366 62.5417C106.366 63.6186 105.492 64.4917 104.416 64.4917C103.339 64.4917 102.466 63.6186 102.466 62.5417Z"
			fill="#58707F"
		/>
		<path
			d="M108.316 62.5417C108.316 61.7339 108.97 61.0792 109.778 61.0792H118.553C119.361 61.0792 120.016 61.7339 120.016 62.5417C120.016 63.3494 119.361 64.0042 118.553 64.0042H109.778C108.97 64.0042 108.316 63.3494 108.316 62.5417Z"
			fill="#58707F"
		/>
		<path
			d="M131.716 62.5417C131.716 61.7339 132.37 61.0792 133.178 61.0792H149.753C150.561 61.0792 151.216 61.7339 151.216 62.5417C151.216 63.3494 150.561 64.0042 149.753 64.0042H133.178C132.37 64.0042 131.716 63.3494 131.716 62.5417Z"
			fill="#58707F"
		/>
		<path
			d="M160.966 62.5418C160.966 61.4648 161.839 60.5918 162.916 60.5918C163.992 60.5918 164.866 61.4648 164.866 62.5418C164.866 63.6187 163.992 64.4918 162.916 64.4918C161.839 64.4918 160.966 63.6187 160.966 62.5418Z"
			fill="#58707F"
		/>
		<path
			d="M166.816 62.5418C166.816 61.7341 167.47 61.0793 168.278 61.0793H177.053C177.861 61.0793 178.516 61.7341 178.516 62.5418C178.516 63.3495 177.861 64.0043 177.053 64.0043H168.278C167.47 64.0043 166.816 63.3495 166.816 62.5418Z"
			fill="#58707F"
		/>
		<path
			d="M190.216 62.5418C190.216 61.7341 190.87 61.0793 191.678 61.0793H208.253C209.061 61.0793 209.716 61.7341 209.716 62.5418C209.716 63.3495 209.061 64.0043 208.253 64.0043H191.678C190.87 64.0043 190.216 63.3495 190.216 62.5418Z"
			fill="#58707F"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M98.4993 68.3915H214.499V69.3915H98.4993V68.3915Z"
			fill="#58707F"
		/>
		<path
			d="M102.466 75.9298C102.466 74.8529 103.339 73.9798 104.416 73.9798C105.492 73.9798 106.366 74.8529 106.366 75.9298C106.366 77.0068 105.492 77.8798 104.416 77.8798C103.339 77.8798 102.466 77.0068 102.466 75.9298Z"
			fill="#58707F"
		/>
		<path
			d="M108.316 75.9298C108.316 75.1221 108.97 74.4673 109.778 74.4673H122.453C123.261 74.4673 123.916 75.1221 123.916 75.9298C123.916 76.7375 123.261 77.3923 122.453 77.3923H109.778C108.97 77.3923 108.316 76.7375 108.316 75.9298Z"
			fill="#58707F"
		/>
		<path
			d="M135.616 75.9297C135.616 75.122 136.27 74.4672 137.078 74.4672H149.753C150.561 74.4672 151.216 75.122 151.216 75.9297C151.216 76.7374 150.561 77.3922 149.753 77.3922H137.078C136.27 77.3922 135.616 76.7374 135.616 75.9297Z"
			fill="#58707F"
		/>
		<path
			d="M160.966 75.9298C160.966 74.8529 161.839 73.9798 162.916 73.9798C163.992 73.9798 164.866 74.8529 164.866 75.9298C164.866 77.0068 163.992 77.8798 162.916 77.8798C161.839 77.8798 160.966 77.0068 160.966 75.9298Z"
			fill="#58707F"
		/>
		<path
			d="M166.815 75.9297C166.815 75.122 167.47 74.4672 168.278 74.4672H180.953C181.761 74.4672 182.415 75.122 182.415 75.9297C182.415 76.7374 181.761 77.3922 180.953 77.3922H168.278C167.47 77.3922 166.815 76.7374 166.815 75.9297Z"
			fill="#58707F"
		/>
		<path
			d="M194.116 75.9297C194.116 75.122 194.77 74.4672 195.578 74.4672H208.253C209.061 74.4672 209.716 75.122 209.716 75.9297C209.716 76.7374 209.061 77.3922 208.253 77.3922H195.578C194.77 77.3922 194.116 76.7374 194.116 75.9297Z"
			fill="#58707F"
		/>
		<path d="M21.5 39.4551H214.5V40.4551H21.5V39.4551Z" fill="#58707F" />
		<path d="M98.5 20.4551H99.5V40.4551H98.5V20.4551Z" fill="#58707F" />
		<path
			d="M43.8997 31.1808C43.8997 30.1038 44.7728 29.2308 45.8497 29.2308H73.1497C74.2267 29.2308 75.0997 30.1038 75.0997 31.1808C75.0997 32.2577 74.2267 33.1308 73.1497 33.1308H45.8497C44.7728 33.1308 43.8997 32.2577 43.8997 31.1808Z"
			fill="#58707F"
		/>
		<path
			d="M142.375 31.1808C142.375 30.1038 143.248 29.2308 144.325 29.2308H171.625C172.702 29.2308 173.575 30.1038 173.575 31.1808C173.575 32.2577 172.702 33.1308 171.625 33.1308H144.325C143.248 33.1308 142.375 32.2577 142.375 31.1808Z"
			fill="#58707F"
		/>
		<path
			d="M59.8305 64.7142H61.5766C61.8761 64.749 62.1778 64.6968 62.4599 64.5615C62.7421 64.4261 62.9977 64.2109 63.2082 63.9314C63.5761 63.3163 63.7593 62.5478 63.7235 61.7695C63.747 61.039 63.5637 60.3227 63.2082 59.7567C63.0059 59.4968 62.7634 59.296 62.4969 59.1674C62.2304 59.0389 61.946 58.9857 61.6625 59.0113C61.1291 58.9943 60.6096 59.233 60.2026 59.6822C60.0163 59.9116 59.8691 60.1894 59.7705 60.4976C59.6719 60.8058 59.6241 61.1375 59.6301 61.4713H56.6245C56.5939 60.7032 56.7054 59.9367 56.9495 59.2362C57.1935 58.5358 57.5631 57.9217 58.0271 57.4458C59.0315 56.3651 60.3028 55.7956 61.6052 55.843C62.9871 55.744 64.3497 56.3001 65.441 57.4085C65.9006 57.9509 66.2603 58.6214 66.4933 59.3701C66.7262 60.1187 66.8264 60.9262 66.7863 61.7323C66.7848 62.6535 66.5649 63.5518 66.1566 64.3041C65.7208 65.1359 65.1164 65.794 64.4105 66.2051C65.2015 66.5445 65.8853 67.2122 66.357 68.1061C66.8183 68.969 67.0587 69.9995 67.044 71.0507C67.0777 71.908 66.9553 72.7634 66.6866 73.5473C66.418 74.3311 66.0108 75.0211 65.4982 75.5608C64.369 76.6916 62.9714 77.2719 61.548 77.2009C60.2278 77.2571 58.9333 76.7172 57.884 75.6727C57.3721 75.1699 56.9669 74.5058 56.7065 73.7429C56.4461 72.9799 56.339 72.1433 56.3955 71.3116H59.258C59.2479 71.6805 59.299 72.0478 59.4076 72.3887C59.5163 72.7296 59.68 73.036 59.8877 73.2871C60.3226 73.8115 60.8982 74.0926 61.4907 74.0699C61.8007 74.0959 62.1114 74.0363 62.4025 73.895C62.6935 73.7536 62.9583 73.5338 63.1796 73.2499C63.3969 72.9689 63.5655 72.6306 63.6742 72.2577C63.7828 71.8848 63.8289 71.486 63.8093 71.088C63.8626 70.6595 63.8374 70.2207 63.7358 69.8073C63.6343 69.3939 63.4592 69.0175 63.2249 68.7088C62.9906 68.4001 62.7037 68.1677 62.3874 68.0306C62.0711 67.8935 61.7345 67.8555 61.4048 67.9197H59.6587L59.8305 64.7142Z"
			fill="#58707F"
		/>
		<path
			d="M79.6673 76.9026H69.1619V74.1816L74.1427 66.9505C74.7301 66.0767 75.248 65.1276 75.6884 64.1177C75.9645 63.4648 76.1213 62.7377 76.1464 61.9931C76.164 61.212 75.9717 60.4473 75.6025 59.8312C75.422 59.5508 75.1929 59.3303 74.9341 59.1877C74.6754 59.0452 74.3943 58.9847 74.114 59.0112C73.8014 58.9806 73.4879 59.0534 73.2026 59.2229C72.9174 59.3923 72.6696 59.6528 72.4824 59.9803C72.1038 60.7591 71.9143 61.6683 71.9385 62.5895H68.9329C68.901 61.7144 69.0064 60.84 69.2427 60.0197C69.4789 59.1994 69.841 58.4504 70.3069 57.8184C70.803 57.1554 71.4013 56.6365 72.0624 56.296C72.7235 55.9556 73.4325 55.8011 74.1427 55.8429C75.5131 55.7406 76.8596 56.3429 77.8925 57.5202C78.3485 58.0979 78.7045 58.7959 78.9365 59.5673C79.1685 60.3387 79.2713 61.1658 79.2379 61.9931C79.2557 63.2185 78.9969 64.4238 78.4937 65.4596C77.7253 66.9433 76.8737 68.3511 75.946 69.6715L73.0835 73.6971H79.6673V76.9026Z"
			fill="#58707F"
		/>
		<path
			d="M82.9019 58.3503C82.8859 57.9325 82.9877 57.5216 83.1882 57.1948C83.2929 57.0456 83.4215 56.9281 83.565 56.8508C83.7084 56.7736 83.8632 56.7383 84.0183 56.7475C84.1779 56.7353 84.3376 56.7691 84.486 56.8464C84.6344 56.9237 84.7679 57.0426 84.877 57.1948C85.0775 57.5216 85.1793 57.9325 85.1633 58.3503C85.182 58.7685 85.0799 59.1807 84.877 59.5058C84.7723 59.655 84.6437 59.7724 84.5002 59.8497C84.3567 59.927 84.202 59.9623 84.0469 59.953C83.8873 59.9652 83.7276 59.9315 83.5792 59.8542C83.4308 59.7769 83.2973 59.6579 83.1882 59.5058C82.9853 59.1807 82.8832 58.7685 82.9019 58.3503ZM83.5317 58.3503C83.4925 58.571 83.4925 58.8005 83.5317 59.0212C83.5735 59.1085 83.6331 59.1791 83.7038 59.2251C83.7745 59.2712 83.8536 59.2909 83.9324 59.2821C84.0034 59.2904 84.0746 59.2697 84.1361 59.223C84.1976 59.1762 84.2465 59.1057 84.2759 59.0212C84.3772 58.8231 84.4274 58.588 84.419 58.3503C84.4224 58.1579 84.3931 57.967 84.3332 57.7912C84.2988 57.7037 84.2448 57.6318 84.1783 57.5852C84.1118 57.5386 84.0361 57.5195 83.961 57.5302C83.8901 57.522 83.8189 57.5426 83.7573 57.5894C83.6958 57.6361 83.6469 57.7067 83.6175 57.7912C83.524 57.9938 83.4746 58.2257 83.4744 58.4621L83.5317 58.3503Z"
			fill="#58707F"
		/>
		<path
			d="M90.0581 61.5927C90.0723 61.9356 90.0313 62.2785 89.9376 62.5995C89.844 62.9205 89.6997 63.2124 89.5142 63.4564C89.0708 63.9248 88.5102 64.1637 87.9398 64.1273C87.6359 64.1527 87.3315 64.0889 87.0491 63.9405C86.7667 63.7921 86.5135 63.563 86.3082 63.27C86.0953 62.9849 85.9295 62.646 85.8212 62.2741C85.7129 61.9023 85.6643 61.5054 85.6785 61.1081V59.6917C85.652 58.8961 85.8681 58.119 86.2796 57.5298C86.7232 57.0239 87.2929 56.7451 87.8826 56.7451C88.4723 56.7451 89.0419 57.0239 89.4856 57.5298C89.6825 57.7645 89.8362 58.0539 89.9353 58.3765C90.0345 58.6992 90.0764 59.0468 90.0581 59.3935H88.9703C88.9901 58.9927 88.8987 58.5959 88.7127 58.2753C88.6018 58.1415 88.4707 58.0392 88.3278 57.975C88.1849 57.9109 88.0333 57.8862 87.8826 57.9026C87.7415 57.9303 87.6068 57.9981 87.4881 58.1012C87.3694 58.2043 87.2695 58.3401 87.1956 58.499C86.9907 58.9078 86.8905 59.3906 86.9093 59.8781V61.2945C86.8855 61.7883 86.9971 62.2771 87.2242 62.6736C87.322 62.8386 87.4479 62.9716 87.592 63.0622C87.7361 63.1527 87.8944 63.1984 88.0543 63.1955C88.1964 63.2134 88.3398 63.1892 88.4736 63.1246C88.6075 63.0601 88.7284 62.9569 88.8272 62.8227C89.0189 62.5205 89.1114 62.1322 89.0848 61.7418L90.0581 61.5927Z"
			fill="#58707F"
		/>
		<path
			d="M82.9019 71.3307C82.8859 70.9129 82.9877 70.502 83.1882 70.1752C83.2929 70.026 83.4215 69.9086 83.565 69.8313C83.7084 69.754 83.8632 69.7187 84.0183 69.7279C84.1779 69.7157 84.3376 69.7495 84.486 69.8268C84.6344 69.9041 84.7679 70.023 84.877 70.1752C85.0775 70.502 85.1793 70.9129 85.1633 71.3307C85.182 71.7489 85.0799 72.1611 84.877 72.4862C84.7723 72.6354 84.6437 72.7528 84.5002 72.8301C84.3567 72.9074 84.202 72.9427 84.0469 72.9335C83.8873 72.9456 83.7276 72.9119 83.5792 72.8346C83.4308 72.7573 83.2973 72.6383 83.1882 72.4862C82.9853 72.1611 82.8832 71.7489 82.9019 71.3307ZM83.5317 71.3307C83.4925 71.5514 83.4925 71.7809 83.5317 72.0016C83.5735 72.0889 83.6331 72.1595 83.7038 72.2055C83.7745 72.2516 83.8536 72.2713 83.9324 72.2625C84.0034 72.2708 84.0746 72.2501 84.1361 72.2034C84.1976 72.1566 84.2465 72.0861 84.2759 72.0016C84.3772 71.8035 84.4274 71.5685 84.419 71.3307C84.4224 71.1383 84.3931 70.9474 84.3332 70.7716C84.2988 70.6841 84.2448 70.6122 84.1783 70.5656C84.1118 70.519 84.0361 70.4999 83.961 70.5107C83.8901 70.5024 83.8189 70.5231 83.7573 70.5698C83.6958 70.6166 83.6469 70.6871 83.6175 70.7716C83.524 70.9742 83.4746 71.2061 83.4744 71.4425L83.5317 71.3307Z"
			fill="#58707F"
		/>
		<path
			d="M89.3421 74.0865H87.1369V77.1802H86.0343V69.7255H89.8383V70.881H87.1369V72.931H89.4524L89.3421 74.0865Z"
			fill="#58707F"
		/>
		<path
			d="M53.3355 66.4201C53.3346 67.745 52.8081 69.0153 51.8716 69.9525C50.9351 70.8897 49.6652 71.417 48.3404 71.4191H35.5213C34.0269 71.3811 32.6066 70.761 31.563 69.6906C30.5195 68.6204 29.9355 67.1848 29.9355 65.6898C29.9355 64.1951 30.5195 62.7594 31.563 61.689C32.6065 60.6188 34.0269 59.9985 35.5213 59.9607H35.6794C35.9453 58.8951 36.5267 57.9348 37.3476 57.2053C38.1684 56.4759 39.1905 56.0113 40.2799 55.8726C41.3692 55.7339 42.4751 55.9274 43.4525 56.4277C44.4301 56.9281 45.2336 57.712 45.7581 58.6769C46.0294 58.6137 46.3071 58.5816 46.5857 58.5812C47.4718 58.5858 48.3258 58.9139 48.9869 59.504C49.648 60.0939 50.0708 60.9051 50.1758 61.7851C51.1048 62.1543 51.902 62.7928 52.4651 63.6188C53.0281 64.4447 53.3313 65.4205 53.3355 66.4201Z"
			fill="#58707F"
		/>
		<path
			d="M21.4253 123.536H214.611V137.14H21.4253V123.536Z"
			fill="#E6EAEC"
		/>
		<path
			d="M21.4251 96.505C21.4251 94.3511 23.1712 92.605 25.3251 92.605H210.711C212.865 92.605 214.611 94.3511 214.611 96.505V107.57H21.4251V96.505Z"
			fill="#DEE2E5"
		/>
		<path
			d="M207.7 136.455V137.455H28.2999V136.455H207.7ZM214.5 129.655V100.405C214.5 98.5384 214.498 97.2391 214.366 96.2593C214.238 95.3082 214.005 94.809 213.651 94.4546C213.296 94.1002 212.797 93.8667 211.846 93.7388C210.866 93.6071 209.567 93.605 207.7 93.605H28.2999C26.4336 93.605 25.1342 93.6071 24.1544 93.7388C23.2033 93.8667 22.7041 94.1002 22.3497 94.4546C21.9954 94.809 21.7618 95.3082 21.6339 96.2593C21.5022 97.2391 21.5001 98.5384 21.5001 100.405V129.655C21.5001 131.522 21.5022 132.821 21.6339 133.801C21.7618 134.752 21.9954 135.252 22.3497 135.606C22.7041 135.96 23.2036 136.193 24.1544 136.321C25.1343 136.453 26.4335 136.455 28.2999 136.455V137.455C24.7378 137.455 22.9009 137.455 21.7511 136.417L21.6427 136.313C20.5004 135.171 20.5001 133.332 20.5001 129.655V100.405C20.5001 96.8428 20.4997 95.0058 21.5382 93.856L21.6427 93.7476C22.785 92.6053 24.6231 92.605 28.2999 92.605H207.7L208.995 92.607C211.826 92.6226 213.358 92.7481 214.358 93.7476C215.5 94.8898 215.5 96.728 215.5 100.405V129.655C215.5 133.332 215.5 135.171 214.358 136.313L214.249 136.417C213.248 137.321 211.725 137.438 208.995 137.453L207.7 137.455V136.455C209.567 136.455 210.866 136.453 211.846 136.321C212.797 136.193 213.296 135.96 213.651 135.606C214.005 135.252 214.238 134.752 214.366 133.801C214.498 132.821 214.5 131.522 214.5 129.655Z"
			fill="#58707F"
		/>
		<path
			d="M109.855 136.546V137.546H58.1573V136.546H109.855ZM111.576 134.825V95.3711C111.576 94.7017 111.574 94.3001 111.535 94.0117C111.517 93.8798 111.496 93.8122 111.483 93.7803C111.478 93.7661 111.473 93.7599 111.473 93.7588C111.472 93.7582 111.472 93.7575 111.471 93.7559C111.469 93.7543 111.468 93.7543 111.468 93.7539C111.467 93.7533 111.461 93.7491 111.446 93.7432C111.414 93.7301 111.347 93.7092 111.215 93.6914C111.071 93.6721 110.898 93.6617 110.678 93.6563L109.855 93.6504H58.1573C57.4879 93.6504 57.0863 93.6527 56.798 93.6914C56.666 93.7092 56.5984 93.7301 56.5665 93.7432C56.5521 93.7491 56.546 93.7533 56.545 93.7539C56.5444 93.7544 56.5437 93.7543 56.5421 93.7559C56.5405 93.7575 56.5406 93.7582 56.5401 93.7588C56.5395 93.7598 56.5353 93.7659 56.5294 93.7803C56.5163 93.8122 56.4954 93.8798 56.4776 94.0117C56.4389 94.3001 56.4366 94.7017 56.4366 95.3711V134.825C56.4366 135.494 56.4389 135.896 56.4776 136.184C56.4954 136.316 56.5163 136.384 56.5294 136.416C56.5353 136.43 56.5395 136.436 56.5401 136.437C56.5405 136.438 56.5406 136.439 56.5421 136.44C56.5437 136.442 56.5444 136.442 56.545 136.442C56.5461 136.443 56.5523 136.447 56.5665 136.453C56.5984 136.466 56.6661 136.487 56.798 136.505C57.0863 136.544 57.4879 136.546 58.1573 136.546V137.546L57.3097 137.539C56.6315 137.522 56.2091 137.458 55.9132 137.218L55.8351 137.147C55.5362 136.848 55.4612 136.413 55.4425 135.673L55.4366 134.825V95.3711C55.4366 94.0886 55.4366 93.4473 55.8351 93.0489C56.2335 92.6504 56.8748 92.6504 58.1573 92.6504H109.855L110.703 92.6563C111.443 92.675 111.879 92.75 112.178 93.0489C112.576 93.4473 112.576 94.0887 112.576 95.3711V134.825L112.57 135.673C112.552 136.413 112.477 136.848 112.178 137.147L112.1 137.218C111.804 137.458 111.381 137.522 110.703 137.539L109.855 137.546V136.546C110.525 136.546 110.927 136.544 111.215 136.505C111.347 136.487 111.414 136.466 111.446 136.453C111.461 136.447 111.467 136.443 111.468 136.442C111.468 136.442 111.469 136.442 111.471 136.44C111.472 136.439 111.472 136.438 111.473 136.437C111.473 136.436 111.477 136.43 111.483 136.416C111.496 136.384 111.517 136.316 111.535 136.184C111.574 135.896 111.576 135.494 111.576 134.825Z"
			fill="#58707F"
		/>
		<path
			d="M82.1296 136.455V137.455H58.321V136.455H82.1296ZM83.8503 134.734V95.3257C83.8503 94.6562 83.8481 94.2546 83.8093 93.9663C83.7916 93.8344 83.7706 93.7668 83.7575 93.7349C83.7516 93.7205 83.7474 93.7143 83.7468 93.7134C83.7464 93.7127 83.7465 93.7121 83.7449 93.7105C83.7432 93.7088 83.7426 93.7089 83.7419 93.7085C83.741 93.7079 83.7348 93.7037 83.7204 93.6978C83.6886 93.6847 83.6209 93.6638 83.489 93.646C83.2007 93.6072 82.7991 93.605 82.1296 93.605H58.321C57.6516 93.605 57.25 93.6072 56.9616 93.646C56.8297 93.6638 56.7621 93.6847 56.7302 93.6978C56.7158 93.7037 56.7097 93.7079 56.7087 93.7085C56.7081 93.7089 56.7074 93.7088 56.7058 93.7105C56.7042 93.7121 56.7043 93.7128 56.7038 93.7134C56.7032 93.7143 56.699 93.7205 56.6931 93.7349C56.68 93.7668 56.6591 93.8344 56.6413 93.9663C56.6026 94.2546 56.6003 94.6562 56.6003 95.3257V134.734C56.6003 135.403 56.6026 135.805 56.6413 136.093C56.6591 136.226 56.68 136.294 56.6931 136.326C56.699 136.34 56.7032 136.346 56.7038 136.347L56.7087 136.352C56.7102 136.353 56.7167 136.356 56.7302 136.362C56.762 136.375 56.8295 136.397 56.9616 136.415C57.25 136.453 57.6516 136.455 58.321 136.455V137.455C57.0385 137.455 56.3972 137.455 55.9988 137.056C55.6005 136.658 55.6003 136.016 55.6003 134.734V95.3257C55.6003 94.0432 55.6003 93.4019 55.9988 93.0034C56.3972 92.605 57.0385 92.605 58.321 92.605H82.1296L82.9773 92.6109C83.7175 92.6295 84.153 92.7046 84.4519 93.0034C84.8503 93.4019 84.8503 94.0432 84.8503 95.3257V134.734L84.8445 135.582C84.8258 136.322 84.7506 136.757 84.4519 137.056L84.3738 137.126C84.0779 137.367 83.6557 137.432 82.9773 137.449L82.1296 137.455V136.455C82.7991 136.455 83.2007 136.453 83.489 136.415C83.6212 136.397 83.6886 136.375 83.7204 136.362C83.7339 136.356 83.7404 136.353 83.7419 136.352L83.7468 136.347C83.7474 136.346 83.7517 136.34 83.7575 136.326C83.7706 136.294 83.7915 136.226 83.8093 136.093C83.848 135.805 83.8503 135.403 83.8503 134.734Z"
			fill="#58707F"
		/>
		<path
			d="M143.78 136.455V137.455H114.221V136.455H143.78ZM145.5 134.734V95.1753C145.5 94.5059 145.498 94.1043 145.459 93.8159C145.442 93.684 145.421 93.6164 145.408 93.5845C145.402 93.5701 145.398 93.564 145.397 93.563C145.397 93.5624 145.397 93.5617 145.395 93.5601C145.393 93.5585 145.393 93.5585 145.392 93.5581C145.391 93.5575 145.385 93.5533 145.371 93.5474C145.339 93.5343 145.271 93.5134 145.139 93.4956C144.851 93.4569 144.449 93.4546 143.78 93.4546H114.221C113.552 93.4546 113.15 93.4569 112.862 93.4956C112.73 93.5134 112.662 93.5343 112.63 93.5474C112.616 93.5533 112.61 93.5575 112.609 93.5581C112.608 93.5585 112.608 93.5585 112.606 93.5601C112.604 93.5617 112.604 93.5624 112.604 93.563C112.603 93.564 112.599 93.5701 112.593 93.5845C112.58 93.6164 112.559 93.684 112.541 93.8159C112.503 94.1043 112.5 94.5059 112.5 95.1753V134.734C112.5 135.403 112.503 135.805 112.541 136.093C112.559 136.225 112.58 136.293 112.593 136.325C112.599 136.339 112.603 136.345 112.604 136.346C112.604 136.347 112.604 136.348 112.606 136.349C112.608 136.351 112.608 136.351 112.609 136.351C112.61 136.352 112.616 136.356 112.63 136.362C112.662 136.375 112.73 136.396 112.862 136.414C113.15 136.452 113.552 136.455 114.221 136.455V137.455C113.019 137.455 112.38 137.455 111.977 137.126L111.899 137.056C111.6 136.757 111.525 136.322 111.506 135.582L111.5 134.734V95.1753C111.5 93.8928 111.5 93.2515 111.899 92.8531C112.297 92.4546 112.939 92.4546 114.221 92.4546H143.78L144.627 92.4605C145.368 92.4791 145.803 92.5542 146.102 92.8531C146.5 93.2515 146.5 93.8928 146.5 95.1753V134.734L146.495 135.582C146.476 136.322 146.401 136.757 146.102 137.056L146.024 137.126C145.728 137.367 145.306 137.432 144.627 137.449L143.78 137.455V136.455C144.449 136.455 144.851 136.452 145.139 136.414C145.271 136.396 145.339 136.375 145.371 136.362C145.385 136.356 145.391 136.352 145.392 136.351C145.393 136.351 145.393 136.351 145.395 136.349C145.397 136.348 145.397 136.347 145.397 136.346C145.398 136.345 145.402 136.339 145.408 136.325C145.421 136.293 145.442 136.225 145.459 136.093C145.498 135.805 145.5 135.403 145.5 134.734Z"
			fill="#58707F"
		/>
		<path
			d="M177.03 136.455V137.455H148.021V136.455H177.03ZM178.75 134.734V95.3257C178.75 94.6562 178.748 94.2546 178.709 93.9663C178.692 93.8344 178.671 93.7668 178.658 93.7349C178.652 93.7208 178.648 93.7145 178.647 93.7134C178.646 93.7127 178.646 93.712 178.645 93.7105C178.643 93.709 178.643 93.7089 178.642 93.7085C178.641 93.7079 178.635 93.7037 178.62 93.6978C178.589 93.6847 178.521 93.6638 178.389 93.646C178.101 93.6073 177.699 93.605 177.03 93.605H148.021C147.351 93.605 146.95 93.6072 146.661 93.646C146.53 93.6638 146.462 93.6847 146.43 93.6978C146.416 93.7037 146.41 93.7079 146.409 93.7085C146.408 93.7089 146.407 93.7088 146.406 93.7105C146.404 93.7121 146.404 93.7128 146.404 93.7134C146.403 93.7143 146.399 93.7205 146.393 93.7349C146.38 93.7668 146.359 93.8344 146.341 93.9663C146.302 94.2546 146.3 94.6562 146.3 95.3257V134.734C146.3 135.403 146.302 135.805 146.341 136.093C146.359 136.226 146.38 136.294 146.393 136.326C146.399 136.34 146.403 136.346 146.404 136.347L146.409 136.352C146.41 136.353 146.417 136.356 146.43 136.362C146.462 136.375 146.529 136.397 146.661 136.415C146.95 136.453 147.351 136.455 148.021 136.455V137.455C146.738 137.455 146.097 137.455 145.699 137.056C145.3 136.658 145.3 136.016 145.3 134.734V95.3257C145.3 94.0432 145.3 93.4019 145.699 93.0034C146.097 92.605 146.738 92.605 148.021 92.605H177.03L177.877 92.6109C178.617 92.6295 179.053 92.7046 179.352 93.0034C179.75 93.4019 179.75 94.0433 179.75 95.3257V134.734L179.744 135.582C179.725 136.322 179.651 136.757 179.352 137.056L179.274 137.126C178.978 137.367 178.556 137.432 177.877 137.449L177.03 137.455V136.455C177.699 136.455 178.101 136.453 178.389 136.415C178.521 136.397 178.589 136.375 178.62 136.362C178.634 136.356 178.641 136.353 178.642 136.352L178.647 136.347C178.647 136.346 178.652 136.34 178.658 136.326C178.671 136.294 178.692 136.226 178.709 136.093C178.748 135.805 178.75 135.403 178.75 134.734Z"
			fill="#58707F"
		/>
		<path
			d="M60.4756 116.005C60.4756 114.928 61.3487 114.055 62.4256 114.055C63.5026 114.055 64.3756 114.928 64.3756 116.005C64.3756 117.082 63.5026 117.955 62.4256 117.955C61.3487 117.955 60.4756 117.082 60.4756 116.005Z"
			fill="#58707F"
		/>
		<path
			d="M66.3256 116.005C66.3256 115.197 66.9804 114.542 67.7881 114.542H76.5631C77.3708 114.542 78.0256 115.197 78.0256 116.005C78.0256 116.813 77.3708 117.467 76.5631 117.467H67.7881C66.9804 117.467 66.3256 116.813 66.3256 116.005Z"
			fill="#58707F"
		/>
		<path
			d="M87.7756 116.005C87.7756 115.197 88.4304 114.542 89.2381 114.542H101.913C102.721 114.542 103.376 115.197 103.376 116.005C103.376 116.813 102.721 117.467 101.913 117.467H89.2381C88.4304 117.467 87.7756 116.813 87.7756 116.005Z"
			fill="#58707F"
		/>
		<path
			d="M117.026 116.005C117.026 115.197 117.68 114.542 118.488 114.542H131.163C131.971 114.542 132.626 115.197 132.626 116.005C132.626 116.813 131.971 117.467 131.163 117.467H118.488C117.68 117.467 117.026 116.813 117.026 116.005Z"
			fill="#58707F"
		/>
		<path
			d="M149.201 116.005C149.201 115.197 149.855 114.542 150.663 114.542H163.338C164.146 114.542 164.801 115.197 164.801 116.005C164.801 116.813 164.146 117.467 163.338 117.467H150.663C149.855 117.467 149.201 116.813 149.201 116.005Z"
			fill="#58707F"
		/>
		<path
			d="M183.326 116.005C183.326 115.197 183.98 114.542 184.788 114.542H199.413C200.221 114.542 200.876 115.197 200.876 116.005C200.876 116.813 200.221 117.467 199.413 117.467H184.788C183.98 117.467 183.326 116.813 183.326 116.005Z"
			fill="#58707F"
		/>
		<path
			d="M205.673 114.747C205.864 114.244 206.427 113.991 206.93 114.182C207.434 114.373 207.687 114.936 207.496 115.44L206.804 117.263C206.612 117.766 206.049 118.019 205.546 117.828C205.043 117.637 204.789 117.074 204.981 116.57L205.673 114.747Z"
			fill="#58707F"
		/>
		<path
			d="M60.4754 129.655C60.4754 128.578 61.3485 127.705 62.4254 127.705C63.5024 127.705 64.3754 128.578 64.3754 129.655C64.3754 130.732 63.5024 131.605 62.4254 131.605C61.3485 131.605 60.4754 130.732 60.4754 129.655Z"
			fill="#58707F"
		/>
		<path
			d="M66.3254 129.655C66.3254 128.847 66.9802 128.192 67.7879 128.192H76.5629C77.3706 128.192 78.0254 128.847 78.0254 129.655C78.0254 130.463 77.3706 131.117 76.5629 131.117H67.7879C66.9802 131.117 66.3254 130.463 66.3254 129.655Z"
			fill="#58707F"
		/>
		<path
			d="M87.7754 129.655C87.7754 128.847 88.4302 128.192 89.2379 128.192H101.913C102.721 128.192 103.375 128.847 103.375 129.655C103.375 130.463 102.721 131.117 101.913 131.117H89.2379C88.4302 131.117 87.7754 130.463 87.7754 129.655Z"
			fill="#58707F"
		/>
		<path
			d="M117.026 129.655C117.026 128.847 117.68 128.192 118.488 128.192H135.063C135.871 128.192 136.526 128.847 136.526 129.655C136.526 130.463 135.871 131.117 135.063 131.117H118.488C117.68 131.117 117.026 130.463 117.026 129.655Z"
			fill="#58707F"
		/>
		<path
			d="M149.201 129.655C149.201 128.847 149.855 128.192 150.663 128.192H167.238C168.046 128.192 168.701 128.847 168.701 129.655C168.701 130.462 168.046 131.117 167.238 131.117H150.663C149.855 131.117 149.201 130.462 149.201 129.655Z"
			fill="#58707F"
		/>
		<path
			d="M183.326 129.655C183.326 128.847 183.981 128.192 184.788 128.192H199.413C200.221 128.192 200.876 128.847 200.876 129.655C200.876 130.462 200.221 131.117 199.413 131.117H184.788C183.981 131.117 183.326 130.462 183.326 129.655Z"
			fill="#58707F"
		/>
		<path
			d="M205.673 128.397C205.864 127.894 206.427 127.64 206.93 127.832C207.434 128.023 207.687 128.586 207.496 129.089L206.804 130.912C206.612 131.416 206.049 131.669 205.546 131.478C205.043 131.286 204.789 130.723 204.981 130.22L205.673 128.397Z"
			fill="#58707F"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M21.5007 122.454H214.501V123.454H21.5007V122.454Z"
			fill="#58707F"
		/>
		<path d="M20.5 107.455H214.5V108.455H20.5V107.455Z" fill="#58707F" />
		<path d="M55.5 92.4546H56.5V136.455H55.5V92.4546Z" fill="#58707F" />
		<path
			d="M26.3504 101.38C26.3504 100.303 27.2235 99.4299 28.3004 99.4299H43.9004C44.9774 99.4299 45.8504 100.303 45.8504 101.38C45.8504 102.457 44.9774 103.33 43.9004 103.33H28.3004C27.2235 103.33 26.3504 102.457 26.3504 101.38Z"
			fill="#58707F"
		/>
		<path
			d="M63.4 101.38C63.4 100.303 64.273 99.4299 65.35 99.4299H75.1C76.1769 99.4299 77.05 100.303 77.05 101.38C77.05 102.457 76.1769 103.33 75.1 103.33H65.35C64.273 103.33 63.4 102.457 63.4 101.38Z"
			fill="#58707F"
		/>
		<path
			d="M90.7003 101.38C90.7003 100.303 91.5733 99.4299 92.6503 99.4299H102.4C103.477 99.4299 104.35 100.303 104.35 101.38C104.35 102.457 103.477 103.33 102.4 103.33H92.6503C91.5733 103.33 90.7003 102.457 90.7003 101.38Z"
			fill="#58707F"
		/>
		<path
			d="M26.3504 116.005C26.3504 114.928 27.2235 114.055 28.3004 114.055H40.0004C41.0774 114.055 41.9504 114.928 41.9504 116.005C41.9504 117.082 41.0774 117.955 40.0004 117.955H28.3004C27.2235 117.955 26.3504 117.082 26.3504 116.005Z"
			fill="#58707F"
		/>
		<path
			d="M26.3504 129.655C26.3504 128.578 27.2235 127.705 28.3004 127.705H47.8004C48.8774 127.705 49.7504 128.578 49.7504 129.655C49.7504 130.732 48.8774 131.605 47.8004 131.605H28.3004C27.2235 131.605 26.3504 130.732 26.3504 129.655Z"
			fill="#58707F"
		/>
		<path
			d="M117.025 101.38C117.025 100.303 117.898 99.4299 118.975 99.4299H136.525C137.602 99.4299 138.475 100.303 138.475 101.38C138.475 102.457 137.602 103.33 136.525 103.33H118.975C117.898 103.33 117.025 102.457 117.025 101.38Z"
			fill="#58707F"
		/>
		<path
			d="M149.532 101.38C149.532 100.303 150.405 99.4299 151.482 99.4299H167.082C168.159 99.4299 169.032 100.303 169.032 101.38C169.032 102.457 168.159 103.33 167.082 103.33H151.482C150.405 103.33 149.532 102.457 149.532 101.38Z"
			fill="#58707F"
		/>
		<path
			d="M182.681 101.38C182.681 100.303 183.554 99.4299 184.631 99.4299H200.231C201.308 99.4299 202.181 100.303 202.181 101.38C202.181 102.457 201.308 103.33 200.231 103.33H184.631C183.554 103.33 182.681 102.457 182.681 101.38Z"
			fill="#58707F"
		/>
	</svg>
);
// template images.
export const TablePresetOne = ( { isPopup = false } ) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ isPopup ? 172 : 119 }
		height={ isPopup ? 114 : 72 }
		fill="none"
		viewBox="0 0 119 72"
	>
		<rect
			width={ 117.962 }
			height={ 70.962 }
			x={ 0.519 }
			y={ 0.519 }
			fill="#fff"
			rx={ 2.249 }
		/>
		<rect
			width={ 117.962 }
			height={ 70.962 }
			x={ 0.519 }
			y={ 0.519 }
			stroke="#8796A1"
			strokeWidth={ 1.038 }
			rx={ 2.249 }
		/>
		<path fill="#DEE2E5" d="M9.877 6.942h98.244v9.686H9.877z" />
		<rect
			width={ 98.475 }
			height={ 31.041 }
			x={ 9.764 }
			y={ 6.596 }
			stroke="#58707F"
			strokeWidth={ 0.692 }
			rx={ 1.637 }
		/>
		<rect
			width={ 29.058 }
			height={ 21.125 }
			x={ 49.43 }
			y={ 16.513 }
			stroke="#58707F"
			strokeWidth={ 0.692 }
			rx={ 0.646 }
		/>
		<rect
			width={ 1.983 }
			height={ 1.983 }
			x={ 51.563 }
			y={ 19.142 }
			fill="#58707F"
			rx={ 0.992 }
		/>
		<rect
			width={ 7.933 }
			height={ 1.488 }
			x={ 54.537 }
			y={ 19.39 }
			fill="#58707F"
			rx={ 0.744 }
		/>
		<rect
			width={ 7.933 }
			height={ 1.488 }
			x={ 68.42 }
			y={ 19.39 }
			fill="#58707F"
			rx={ 0.744 }
		/>
		<rect
			width={ 1.983 }
			height={ 1.983 }
			x={ 81.313 }
			y={ 19.142 }
			fill="#58707F"
			rx={ 0.992 }
		/>
		<rect
			width={ 7.933 }
			height={ 1.488 }
			x={ 84.287 }
			y={ 19.39 }
			fill="#58707F"
			rx={ 0.744 }
		/>
		<rect
			width={ 7.933 }
			height={ 1.488 }
			x={ 98.17 }
			y={ 19.39 }
			fill="#58707F"
			rx={ 0.744 }
		/>
		<path
			fill="#58707F"
			fillRule="evenodd"
			d="M49.084 23.108h58.808v.692H49.084v-.692Z"
			clipRule="evenodd"
		/>
		<rect
			width={ 1.983 }
			height={ 1.983 }
			x={ 51.102 }
			y={ 26.591 }
			fill="#58707F"
			rx={ 0.992 }
		/>
		<rect
			width={ 5.95 }
			height={ 1.488 }
			x={ 54.076 }
			y={ 26.839 }
			fill="#58707F"
			rx={ 0.744 }
		/>
		<rect
			width={ 9.917 }
			height={ 1.488 }
			x={ 65.977 }
			y={ 26.838 }
			fill="#58707F"
			rx={ 0.744 }
		/>
		<rect
			width={ 1.983 }
			height={ 1.983 }
			x={ 80.852 }
			y={ 26.591 }
			fill="#58707F"
			rx={ 0.992 }
		/>
		<rect
			width={ 5.95 }
			height={ 1.488 }
			x={ 83.826 }
			y={ 26.839 }
			fill="#58707F"
			rx={ 0.744 }
		/>
		<rect
			width={ 9.917 }
			height={ 1.488 }
			x={ 95.727 }
			y={ 26.838 }
			fill="#58707F"
			rx={ 0.744 }
		/>
		<path
			fill="#58707F"
			fillRule="evenodd"
			d="M49.084 30.558h58.808v.691H49.084v-.691Z"
			clipRule="evenodd"
		/>
		<rect
			width={ 1.983 }
			height={ 1.983 }
			x={ 51.102 }
			y={ 33.464 }
			fill="#58707F"
			rx={ 0.992 }
		/>
		<rect
			width={ 7.933 }
			height={ 1.488 }
			x={ 54.076 }
			y={ 33.712 }
			fill="#58707F"
			rx={ 0.744 }
		/>
		<rect
			width={ 7.933 }
			height={ 1.488 }
			x={ 67.959 }
			y={ 33.712 }
			fill="#58707F"
			rx={ 0.744 }
		/>
		<rect
			width={ 1.983 }
			height={ 1.983 }
			x={ 80.852 }
			y={ 33.464 }
			fill="#58707F"
			rx={ 0.992 }
		/>
		<rect
			width={ 7.933 }
			height={ 1.488 }
			x={ 83.826 }
			y={ 33.712 }
			fill="#58707F"
			rx={ 0.744 }
		/>
		<rect
			width={ 7.933 }
			height={ 1.488 }
			x={ 97.709 }
			y={ 33.712 }
			fill="#58707F"
			rx={ 0.744 }
		/>
		<path fill="#58707F" d="M9.877 15.936h98.244v.692H9.877z" />
		<path fill="#58707F" d="M49.315 6.25h.692v10.378h-.692z" />
		<rect
			width={ 15.867 }
			height={ 1.983 }
			x={ 21.316 }
			y={ 10.712 }
			fill="#58707F"
			rx={ 0.992 }
		/>
		<rect
			width={ 15.867 }
			height={ 1.983 }
			x={ 71.397 }
			y={ 10.712 }
			fill="#58707F"
			rx={ 0.992 }
		/>
		<path
			fill="#58707F"
			d="M29.418 28.758h.888a.815.815 0 0 0 .45-.078c.143-.068.273-.178.38-.32.187-.313.28-.704.262-1.1a1.831 1.831 0 0 0-.262-1.023 1.032 1.032 0 0 0-.362-.3.806.806 0 0 0-.424-.08c-.271-.008-.535.114-.742.342-.095.117-.17.258-.22.415-.05.156-.075.325-.072.495h-1.528a3.1 3.1 0 0 1 .165-1.137c.124-.356.312-.668.548-.91.511-.55 1.158-.84 1.82-.815.703-.05 1.396.232 1.95.796.234.276.417.617.536.997.118.381.17.792.149 1.202-.001.468-.113.925-.32 1.308-.222.423-.53.757-.889.966.403.173.75.513.99.967.235.439.357.963.35 1.497.017.436-.045.872-.182 1.27-.137.399-.344.75-.604 1.024-.575.575-1.285.87-2.01.834-.67.029-1.329-.246-1.863-.777a2.505 2.505 0 0 1-.598-.981 3.184 3.184 0 0 1-.158-1.237h1.455c-.005.188.021.375.076.548.056.173.139.33.245.457.22.267.513.41.815.398a.886.886 0 0 0 .463-.089c.148-.072.283-.184.396-.328a1.52 1.52 0 0 0 .251-.505 1.82 1.82 0 0 0 .069-.595 1.808 1.808 0 0 0-.038-.65 1.526 1.526 0 0 0-.26-.56 1.08 1.08 0 0 0-.425-.344.84.84 0 0 0-.5-.057h-.888l.087-1.63ZM39.507 34.956h-5.343v-1.383l2.533-3.678c.299-.444.562-.927.786-1.44.14-.332.22-.702.233-1.08a2.068 2.068 0 0 0-.276-1.1.964.964 0 0 0-.34-.327.719.719 0 0 0-.417-.09.757.757 0 0 0-.464.107 1.046 1.046 0 0 0-.366.386 2.883 2.883 0 0 0-.277 1.327h-1.528c-.017-.445.037-.89.157-1.307.12-.417.305-.798.541-1.12.253-.337.557-.6.893-.774a2.037 2.037 0 0 1 1.058-.23c.697-.052 1.382.254 1.907.853.232.293.413.648.531 1.04.118.393.17.814.153 1.234a3.93 3.93 0 0 1-.378 1.763c-.39.755-.824 1.47-1.296 2.142l-1.456 2.047h3.349v1.63ZM41.151 25.522a1.057 1.057 0 0 1 .146-.587.565.565 0 0 1 .192-.175.43.43 0 0 1 .23-.053.439.439 0 0 1 .238.05c.076.04.143.1.199.178.102.166.154.375.145.587.01.213-.042.423-.145.588a.563.563 0 0 1-.192.175.43.43 0 0 1-.23.052.44.44 0 0 1-.238-.05.577.577 0 0 1-.199-.177 1.034 1.034 0 0 1-.145-.588Zm.32 0a.982.982 0 0 0 0 .341c.022.045.052.08.088.104a.176.176 0 0 0 .117.03.143.143 0 0 0 .103-.03.217.217 0 0 0 .071-.104.7.7 0 0 0 .073-.34.84.84 0 0 0-.044-.285.229.229 0 0 0-.078-.105.153.153 0 0 0-.11-.028.143.143 0 0 0-.105.03.218.218 0 0 0-.07.103.822.822 0 0 0-.073.341l.029-.057ZM44.791 27.171a1.6 1.6 0 0 1-.061.512 1.341 1.341 0 0 1-.216.436c-.225.238-.51.36-.8.341a.822.822 0 0 1-.453-.095 1.08 1.08 0 0 1-.377-.34 1.59 1.59 0 0 1-.248-.507c-.055-.19-.08-.391-.072-.593v-.72c-.014-.405.096-.8.305-1.1.226-.257.516-.4.816-.4.3 0 .59.143.815.4.1.12.178.267.228.43.051.165.072.341.063.518h-.553a1.043 1.043 0 0 0-.131-.569.55.55 0 0 0-.196-.153.434.434 0 0 0-.226-.036.435.435 0 0 0-.201.1.603.603 0 0 0-.149.203 1.452 1.452 0 0 0-.145.701v.72c-.012.252.044.5.16.702a.58.58 0 0 0 .187.198c.073.046.154.069.235.067a.379.379 0 0 0 .213-.036.491.491 0 0 0 .18-.153.921.921 0 0 0 .131-.55l.495-.076ZM41.151 32.123a1.057 1.057 0 0 1 .146-.588.565.565 0 0 1 .192-.175.43.43 0 0 1 .23-.052.439.439 0 0 1 .238.05c.076.04.143.1.199.177.102.166.154.375.145.588.01.213-.042.422-.145.588a.563.563 0 0 1-.192.175.43.43 0 0 1-.23.052.44.44 0 0 1-.238-.05.574.574 0 0 1-.199-.177 1.034 1.034 0 0 1-.145-.588Zm.32 0a.982.982 0 0 0 0 .341c.022.045.052.08.088.104a.176.176 0 0 0 .117.029.143.143 0 0 0 .103-.03.217.217 0 0 0 .071-.103.7.7 0 0 0 .073-.341.84.84 0 0 0-.044-.284.229.229 0 0 0-.078-.105.153.153 0 0 0-.11-.028.143.143 0 0 0-.105.03.218.218 0 0 0-.07.103.822.822 0 0 0-.073.34l.029-.056ZM44.426 33.524h-1.121v1.574h-.56v-3.791h1.934v.587h-1.374v1.043h1.177l-.056.587ZM26.275 29.52a2.544 2.544 0 0 1-2.54 2.542h-6.52a2.915 2.915 0 0 1 0-5.827h.081a2.772 2.772 0 0 1 5.126-.653 1.848 1.848 0 0 1 2.247 1.58 2.548 2.548 0 0 1 1.606 2.357Z"
		/>
		<path fill="#E6EAEC" d="M9.887 58.163h98.244v6.919H9.887z" />
		<path
			fill="#DEE2E5"
			d="M9.887 44.925c0-1.095.888-1.983 1.983-1.983h94.278c1.095 0 1.983.888 1.983 1.983v5.627H9.887v-5.627Z"
		/>
		<rect
			width={ 98.475 }
			height={ 22.116 }
			x={ 9.764 }
			y={ 43.288 }
			stroke="#58707F"
			strokeWidth={ 0.692 }
			rx={ 1.637 }
		/>
		<rect
			width={ 28.366 }
			height={ 22.14 }
			x={ 27.529 }
			y={ 43.31 }
			stroke="#58707F"
			strokeWidth={ 0.692 }
			rx={ 0.346 }
		/>
		<mask id="a" fill="#fff">
			<path d="M27.268 44.325c0-.652 0-.978.202-1.18.203-.204.529-.204 1.181-.204H40.76c.652 0 .978 0 1.18.203.204.203.204.529.204 1.181v20.041c0 .652 0 .979-.203 1.181-.203.203-.529.203-1.181.203H28.65c-.652 0-.978 0-1.18-.203-.203-.202-.203-.529-.203-1.18V44.324Z" />
		</mask>
		<path
			fill="#58707F"
			d="M27.268 42.941h14.875-14.875ZM42.143 65.75H27.268h14.875Zm-14.875 0V42.94 65.75ZM41.45 42.94c.764 0 1.383.62 1.383 1.384v20.041c0 .764-.62 1.384-1.383 1.384V42.94Z"
			mask="url(#a)"
		/>
		<mask id="b" fill="#fff">
			<path d="M56.242 44.348c0-.652 0-.978.203-1.18.203-.203.529-.203 1.18-.203h14.53c.652 0 .978 0 1.181.202.203.203.203.529.203 1.181v20.064c0 .652 0 .979-.203 1.181-.203.203-.529.203-1.181.203h-14.53c-.651 0-.977 0-1.18-.203-.203-.202-.203-.529-.203-1.18V44.347Z" />
		</mask>
		<path
			fill="#58707F"
			d="M56.242 42.965H73.54 56.242Zm17.297 22.83H56.242 73.54Zm-17.297 0v-22.83 22.83Zm16.605-22.83c.764 0 1.384.619 1.384 1.383v20.064c0 .764-.62 1.384-1.384 1.384V42.965Z"
			mask="url(#b)"
		/>
		<mask id="c" fill="#fff">
			<path d="M72.883 44.325c0-.652 0-.978.203-1.18.202-.204.528-.204 1.18-.204h14.752c.653 0 .979 0 1.182.203.202.203.202.529.202 1.181v20.041c0 .652 0 .979-.202 1.181-.203.203-.53.203-1.181.203H74.266c-.652 0-.978 0-1.18-.203-.203-.202-.203-.529-.203-1.18V44.324Z" />
		</mask>
		<path
			fill="#58707F"
			d="M72.883 42.941h17.52-17.52Zm17.52 22.809h-17.52 17.52Zm-17.52 0V42.94 65.75ZM89.71 42.94c.765 0 1.384.62 1.384 1.384v20.041c0 .764-.62 1.384-1.384 1.384V42.94Z"
			mask="url(#c)"
		/>
		<rect
			width={ 1.983 }
			height={ 1.983 }
			x={ 29.746 }
			y={ 53.85 }
			fill="#58707F"
			rx={ 0.992 }
		/>
		<rect
			width={ 5.95 }
			height={ 1.488 }
			x={ 32.721 }
			y={ 54.098 }
			fill="#58707F"
			rx={ 0.744 }
		/>
		<rect
			width={ 7.933 }
			height={ 1.488 }
			x={ 43.629 }
			y={ 54.098 }
			fill="#58707F"
			rx={ 0.744 }
		/>
		<rect
			width={ 7.933 }
			height={ 1.488 }
			x={ 58.504 }
			y={ 54.098 }
			fill="#58707F"
			rx={ 0.744 }
		/>
		<rect
			width={ 7.933 }
			height={ 1.488 }
			x={ 74.867 }
			y={ 54.098 }
			fill="#58707F"
			rx={ 0.744 }
		/>
		<rect
			width={ 8.925 }
			height={ 1.488 }
			x={ 92.221 }
			y={ 54.098 }
			fill="#58707F"
			rx={ 0.744 }
		/>
		<rect
			width={ 0.992 }
			height={ 1.983 }
			x={ 103.762 }
			y={ 53.739 }
			fill="#58707F"
			rx={ 0.496 }
			transform="rotate(20.791 103.762 53.739)"
		/>
		<rect
			width={ 1.983 }
			height={ 1.983 }
			x={ 29.746 }
			y={ 60.792 }
			fill="#58707F"
			rx={ 0.992 }
		/>
		<rect
			width={ 5.95 }
			height={ 1.488 }
			x={ 32.721 }
			y={ 61.04 }
			fill="#58707F"
			rx={ 0.744 }
		/>
		<rect
			width={ 7.933 }
			height={ 1.488 }
			x={ 43.629 }
			y={ 61.04 }
			fill="#58707F"
			rx={ 0.744 }
		/>
		<rect
			width={ 9.917 }
			height={ 1.488 }
			x={ 58.504 }
			y={ 61.04 }
			fill="#58707F"
			rx={ 0.744 }
		/>
		<rect
			width={ 9.917 }
			height={ 1.488 }
			x={ 74.867 }
			y={ 61.04 }
			fill="#58707F"
			rx={ 0.744 }
		/>
		<rect
			width={ 8.925 }
			height={ 1.488 }
			x={ 92.221 }
			y={ 61.04 }
			fill="#58707F"
			rx={ 0.744 }
		/>
		<rect
			width={ 0.992 }
			height={ 1.983 }
			x={ 103.762 }
			y={ 60.68 }
			fill="#58707F"
			rx={ 0.496 }
			transform="rotate(20.791 103.762 60.68)"
		/>
		<path
			fill="#58707F"
			fillRule="evenodd"
			d="M9.887 58.163h98.244v.691H9.887v-.691Z"
			clipRule="evenodd"
		/>
		<path fill="#58707F" d="M9.666 50.552h98.244v.692H9.666z" />
		<path fill="#58707F" d="M27.184 42.941h.692v22.14h-.692z" />
		<rect
			width={ 9.917 }
			height={ 1.983 }
			x={ 12.393 }
			y={ 46.413 }
			fill="#58707F"
			rx={ 0.992 }
		/>
		<rect
			width={ 6.942 }
			height={ 1.983 }
			x={ 31.234 }
			y={ 46.413 }
			fill="#58707F"
			rx={ 0.992 }
		/>
		<rect
			width={ 6.942 }
			height={ 1.983 }
			x={ 45.117 }
			y={ 46.413 }
			fill="#58707F"
			rx={ 0.992 }
		/>
		<rect
			width={ 7.933 }
			height={ 1.983 }
			x={ 12.393 }
			y={ 53.85 }
			fill="#58707F"
			rx={ 0.992 }
		/>
		<rect
			width={ 11.9 }
			height={ 1.983 }
			x={ 12.393 }
			y={ 60.792 }
			fill="#58707F"
			rx={ 0.992 }
		/>
		<rect
			width={ 10.908 }
			height={ 1.983 }
			x={ 58.504 }
			y={ 46.413 }
			fill="#58707F"
			rx={ 0.992 }
		/>
		<rect
			width={ 9.917 }
			height={ 1.983 }
			x={ 75.035 }
			y={ 46.413 }
			fill="#58707F"
			rx={ 0.992 }
		/>
		<rect
			width={ 9.917 }
			height={ 1.983 }
			x={ 91.894 }
			y={ 46.413 }
			fill="#58707F"
			rx={ 0.992 }
		/>
	</svg>
);
export const TablePresetTwo = ( { isPopup = false } ) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ isPopup ? 172 : 119 }
		height={ isPopup ? 114 : 72 }
		fill="none"
		viewBox="0 0 119 72"
	>
		<rect
			width={ 117.962 }
			height={ 70.962 }
			x={ 0.519 }
			y={ 0.519 }
			fill="#fff"
			rx={ 2.249 }
		/>
		<rect
			width={ 117.962 }
			height={ 70.962 }
			x={ 0.519 }
			y={ 0.519 }
			stroke="#8796A1"
			strokeWidth={ 1.038 }
			rx={ 2.249 }
		/>
		<path fill="#DEE2E5" d="M9.877 6.942h98.244v9.686H9.877z" />
		<rect
			width={ 98.475 }
			height={ 31.041 }
			x={ 9.764 }
			y={ 6.596 }
			stroke="#58707F"
			strokeWidth={ 0.692 }
			rx={ 1.637 }
		/>
		<rect
			width={ 29.058 }
			height={ 21.125 }
			x={ 49.43 }
			y={ 16.513 }
			stroke="#58707F"
			strokeWidth={ 0.692 }
			rx={ 0.646 }
		/>
		<rect
			width={ 1.983 }
			height={ 1.983 }
			x={ 51.563 }
			y={ 19.142 }
			fill="#58707F"
			rx={ 0.992 }
		/>
		<rect
			width={ 7.933 }
			height={ 1.488 }
			x={ 54.537 }
			y={ 19.39 }
			fill="#58707F"
			rx={ 0.744 }
		/>
		<rect
			width={ 7.933 }
			height={ 1.488 }
			x={ 68.42 }
			y={ 19.39 }
			fill="#58707F"
			rx={ 0.744 }
		/>
		<rect
			width={ 1.983 }
			height={ 1.983 }
			x={ 81.313 }
			y={ 19.142 }
			fill="#58707F"
			rx={ 0.992 }
		/>
		<rect
			width={ 7.933 }
			height={ 1.488 }
			x={ 84.287 }
			y={ 19.39 }
			fill="#58707F"
			rx={ 0.744 }
		/>
		<rect
			width={ 7.933 }
			height={ 1.488 }
			x={ 98.17 }
			y={ 19.39 }
			fill="#58707F"
			rx={ 0.744 }
		/>
		<path
			fill="#58707F"
			fillRule="evenodd"
			d="M49.084 23.108h58.808v.692H49.084v-.692Z"
			clipRule="evenodd"
		/>
		<rect
			width={ 1.983 }
			height={ 1.983 }
			x={ 51.102 }
			y={ 26.591 }
			fill="#58707F"
			rx={ 0.992 }
		/>
		<rect
			width={ 5.95 }
			height={ 1.488 }
			x={ 54.076 }
			y={ 26.839 }
			fill="#58707F"
			rx={ 0.744 }
		/>
		<rect
			width={ 9.917 }
			height={ 1.488 }
			x={ 65.977 }
			y={ 26.838 }
			fill="#58707F"
			rx={ 0.744 }
		/>
		<rect
			width={ 1.983 }
			height={ 1.983 }
			x={ 80.852 }
			y={ 26.591 }
			fill="#58707F"
			rx={ 0.992 }
		/>
		<rect
			width={ 5.95 }
			height={ 1.488 }
			x={ 83.826 }
			y={ 26.839 }
			fill="#58707F"
			rx={ 0.744 }
		/>
		<rect
			width={ 9.917 }
			height={ 1.488 }
			x={ 95.727 }
			y={ 26.838 }
			fill="#58707F"
			rx={ 0.744 }
		/>
		<path
			fill="#58707F"
			fillRule="evenodd"
			d="M49.084 30.558h58.808v.691H49.084v-.691Z"
			clipRule="evenodd"
		/>
		<rect
			width={ 1.983 }
			height={ 1.983 }
			x={ 51.102 }
			y={ 33.464 }
			fill="#58707F"
			rx={ 0.992 }
		/>
		<rect
			width={ 7.933 }
			height={ 1.488 }
			x={ 54.076 }
			y={ 33.712 }
			fill="#58707F"
			rx={ 0.744 }
		/>
		<rect
			width={ 7.933 }
			height={ 1.488 }
			x={ 67.959 }
			y={ 33.712 }
			fill="#58707F"
			rx={ 0.744 }
		/>
		<rect
			width={ 1.983 }
			height={ 1.983 }
			x={ 80.852 }
			y={ 33.464 }
			fill="#58707F"
			rx={ 0.992 }
		/>
		<rect
			width={ 7.933 }
			height={ 1.488 }
			x={ 83.826 }
			y={ 33.712 }
			fill="#58707F"
			rx={ 0.744 }
		/>
		<rect
			width={ 7.933 }
			height={ 1.488 }
			x={ 97.709 }
			y={ 33.712 }
			fill="#58707F"
			rx={ 0.744 }
		/>
		<path fill="#58707F" d="M9.877 15.936h98.244v.692H9.877z" />
		<path fill="#58707F" d="M49.315 6.25h.692v10.378h-.692z" />
		<rect
			width={ 15.867 }
			height={ 1.983 }
			x={ 21.316 }
			y={ 10.712 }
			fill="#58707F"
			rx={ 0.992 }
		/>
		<rect
			width={ 15.867 }
			height={ 1.983 }
			x={ 71.397 }
			y={ 10.712 }
			fill="#58707F"
			rx={ 0.992 }
		/>
		<path
			fill="#58707F"
			d="M29.418 28.758h.888a.815.815 0 0 0 .45-.078c.143-.068.273-.178.38-.32.187-.313.28-.704.262-1.1a1.831 1.831 0 0 0-.262-1.023 1.032 1.032 0 0 0-.362-.3.806.806 0 0 0-.424-.08c-.271-.008-.535.114-.742.342-.095.117-.17.258-.22.415-.05.156-.075.325-.072.495h-1.528a3.1 3.1 0 0 1 .165-1.137c.124-.356.312-.668.548-.91.511-.55 1.158-.84 1.82-.815.703-.05 1.396.232 1.95.796.234.276.417.617.536.997.118.381.17.792.149 1.202-.001.468-.113.925-.32 1.308-.222.423-.53.757-.889.966.403.173.75.513.99.967.235.439.357.963.35 1.497.017.436-.045.872-.182 1.27-.137.399-.344.75-.604 1.024-.575.575-1.285.87-2.01.834-.67.029-1.329-.246-1.863-.777a2.505 2.505 0 0 1-.598-.981 3.184 3.184 0 0 1-.158-1.237h1.455c-.005.188.021.375.076.548.056.173.139.33.245.457.22.267.513.41.815.398a.886.886 0 0 0 .463-.089c.148-.072.283-.184.396-.328a1.52 1.52 0 0 0 .251-.505 1.82 1.82 0 0 0 .069-.595 1.808 1.808 0 0 0-.038-.65 1.526 1.526 0 0 0-.26-.56 1.08 1.08 0 0 0-.425-.344.84.84 0 0 0-.5-.057h-.888l.087-1.63ZM39.507 34.956h-5.343v-1.383l2.533-3.678c.299-.444.562-.927.786-1.44.14-.332.22-.702.233-1.08a2.068 2.068 0 0 0-.276-1.1.964.964 0 0 0-.34-.327.719.719 0 0 0-.417-.09.757.757 0 0 0-.464.107 1.046 1.046 0 0 0-.366.386 2.883 2.883 0 0 0-.277 1.327h-1.528c-.017-.445.037-.89.157-1.307.12-.417.305-.798.541-1.12.253-.337.557-.6.893-.774a2.037 2.037 0 0 1 1.058-.23c.697-.052 1.382.254 1.907.853.232.293.413.648.531 1.04.118.393.17.814.153 1.234a3.93 3.93 0 0 1-.378 1.763c-.39.755-.824 1.47-1.296 2.142l-1.456 2.047h3.349v1.63ZM41.151 25.522a1.057 1.057 0 0 1 .146-.587.565.565 0 0 1 .192-.175.43.43 0 0 1 .23-.053.439.439 0 0 1 .238.05c.076.04.143.1.199.178.102.166.154.375.145.587.01.213-.042.423-.145.588a.563.563 0 0 1-.192.175.43.43 0 0 1-.23.052.44.44 0 0 1-.238-.05.577.577 0 0 1-.199-.177 1.034 1.034 0 0 1-.145-.588Zm.32 0a.982.982 0 0 0 0 .341c.022.045.052.08.088.104a.176.176 0 0 0 .117.03.143.143 0 0 0 .103-.03.217.217 0 0 0 .071-.104.7.7 0 0 0 .073-.34.84.84 0 0 0-.044-.285.229.229 0 0 0-.078-.105.153.153 0 0 0-.11-.028.143.143 0 0 0-.105.03.218.218 0 0 0-.07.103.822.822 0 0 0-.073.341l.029-.057ZM44.791 27.171a1.6 1.6 0 0 1-.061.512 1.341 1.341 0 0 1-.216.436c-.225.238-.51.36-.8.341a.822.822 0 0 1-.453-.095 1.08 1.08 0 0 1-.377-.34 1.59 1.59 0 0 1-.248-.507c-.055-.19-.08-.391-.072-.593v-.72c-.014-.405.096-.8.305-1.1.226-.257.516-.4.816-.4.3 0 .59.143.815.4.1.12.178.267.228.43.051.165.072.341.063.518h-.553a1.043 1.043 0 0 0-.131-.569.55.55 0 0 0-.196-.153.434.434 0 0 0-.226-.036.435.435 0 0 0-.201.1.603.603 0 0 0-.149.203 1.452 1.452 0 0 0-.145.701v.72c-.012.252.044.5.16.702a.58.58 0 0 0 .187.198c.073.046.154.069.235.067a.379.379 0 0 0 .213-.036.491.491 0 0 0 .18-.153.921.921 0 0 0 .131-.55l.495-.076ZM41.151 32.123a1.057 1.057 0 0 1 .146-.588.565.565 0 0 1 .192-.175.43.43 0 0 1 .23-.052.439.439 0 0 1 .238.05c.076.04.143.1.199.177.102.166.154.375.145.588.01.213-.042.422-.145.588a.563.563 0 0 1-.192.175.43.43 0 0 1-.23.052.44.44 0 0 1-.238-.05.574.574 0 0 1-.199-.177 1.034 1.034 0 0 1-.145-.588Zm.32 0a.982.982 0 0 0 0 .341c.022.045.052.08.088.104a.176.176 0 0 0 .117.029.143.143 0 0 0 .103-.03.217.217 0 0 0 .071-.103.7.7 0 0 0 .073-.341.84.84 0 0 0-.044-.284.229.229 0 0 0-.078-.105.153.153 0 0 0-.11-.028.143.143 0 0 0-.105.03.218.218 0 0 0-.07.103.822.822 0 0 0-.073.34l.029-.056ZM44.426 33.524h-1.121v1.574h-.56v-3.791h1.934v.587h-1.374v1.043h1.177l-.056.587ZM26.275 29.52a2.544 2.544 0 0 1-2.54 2.542h-6.52a2.915 2.915 0 0 1 0-5.827h.081a2.772 2.772 0 0 1 5.126-.653 1.848 1.848 0 0 1 2.247 1.58 2.548 2.548 0 0 1 1.606 2.357Z"
		/>
		<path fill="#E6EAEC" d="M9.887 58.163h98.244v6.919H9.887z" />
		<path
			fill="#DEE2E5"
			d="M9.887 44.925c0-1.095.888-1.983 1.983-1.983h94.278c1.095 0 1.983.888 1.983 1.983v5.627H9.887v-5.627Z"
		/>
		<rect
			width={ 98.475 }
			height={ 22.116 }
			x={ 9.764 }
			y={ 43.288 }
			stroke="#58707F"
			strokeWidth={ 0.692 }
			rx={ 1.637 }
		/>
		<rect
			width={ 28.366 }
			height={ 22.14 }
			x={ 27.529 }
			y={ 43.31 }
			stroke="#58707F"
			strokeWidth={ 0.692 }
			rx={ 0.346 }
		/>
		<mask id="a" fill="#fff">
			<path d="M27.268 44.325c0-.652 0-.978.202-1.18.203-.204.529-.204 1.181-.204H40.76c.652 0 .978 0 1.18.203.204.203.204.529.204 1.181v20.041c0 .652 0 .979-.203 1.181-.203.203-.529.203-1.181.203H28.65c-.652 0-.978 0-1.18-.203-.203-.202-.203-.529-.203-1.18V44.324Z" />
		</mask>
		<path
			fill="#58707F"
			d="M27.268 42.941h14.875-14.875ZM42.143 65.75H27.268h14.875Zm-14.875 0V42.94 65.75ZM41.45 42.94c.764 0 1.383.62 1.383 1.384v20.041c0 .764-.62 1.384-1.383 1.384V42.94Z"
			mask="url(#a)"
		/>
		<mask id="b" fill="#fff">
			<path d="M56.242 44.348c0-.652 0-.978.203-1.18.203-.203.529-.203 1.18-.203h14.53c.652 0 .978 0 1.181.202.203.203.203.529.203 1.181v20.064c0 .652 0 .979-.203 1.181-.203.203-.529.203-1.181.203h-14.53c-.651 0-.977 0-1.18-.203-.203-.202-.203-.529-.203-1.18V44.347Z" />
		</mask>
		<path
			fill="#58707F"
			d="M56.242 42.965H73.54 56.242Zm17.297 22.83H56.242 73.54Zm-17.297 0v-22.83 22.83Zm16.605-22.83c.764 0 1.384.619 1.384 1.383v20.064c0 .764-.62 1.384-1.384 1.384V42.965Z"
			mask="url(#b)"
		/>
		<mask id="c" fill="#fff">
			<path d="M72.883 44.325c0-.652 0-.978.203-1.18.202-.204.528-.204 1.18-.204h14.752c.653 0 .979 0 1.182.203.202.203.202.529.202 1.181v20.041c0 .652 0 .979-.202 1.181-.203.203-.53.203-1.181.203H74.266c-.652 0-.978 0-1.18-.203-.203-.202-.203-.529-.203-1.18V44.324Z" />
		</mask>
		<path
			fill="#58707F"
			d="M72.883 42.941h17.52-17.52Zm17.52 22.809h-17.52 17.52Zm-17.52 0V42.94 65.75ZM89.71 42.94c.765 0 1.384.62 1.384 1.384v20.041c0 .764-.62 1.384-1.384 1.384V42.94Z"
			mask="url(#c)"
		/>
		<rect
			width={ 1.983 }
			height={ 1.983 }
			x={ 29.746 }
			y={ 53.85 }
			fill="#58707F"
			rx={ 0.992 }
		/>
		<rect
			width={ 5.95 }
			height={ 1.488 }
			x={ 32.721 }
			y={ 54.098 }
			fill="#58707F"
			rx={ 0.744 }
		/>
		<rect
			width={ 7.933 }
			height={ 1.488 }
			x={ 43.629 }
			y={ 54.098 }
			fill="#58707F"
			rx={ 0.744 }
		/>
		<rect
			width={ 7.933 }
			height={ 1.488 }
			x={ 58.504 }
			y={ 54.098 }
			fill="#58707F"
			rx={ 0.744 }
		/>
		<rect
			width={ 7.933 }
			height={ 1.488 }
			x={ 74.867 }
			y={ 54.098 }
			fill="#58707F"
			rx={ 0.744 }
		/>
		<rect
			width={ 8.925 }
			height={ 1.488 }
			x={ 92.221 }
			y={ 54.098 }
			fill="#58707F"
			rx={ 0.744 }
		/>
		<rect
			width={ 0.992 }
			height={ 1.983 }
			x={ 103.762 }
			y={ 53.739 }
			fill="#58707F"
			rx={ 0.496 }
			transform="rotate(20.791 103.762 53.739)"
		/>
		<rect
			width={ 1.983 }
			height={ 1.983 }
			x={ 29.746 }
			y={ 60.792 }
			fill="#58707F"
			rx={ 0.992 }
		/>
		<rect
			width={ 5.95 }
			height={ 1.488 }
			x={ 32.721 }
			y={ 61.04 }
			fill="#58707F"
			rx={ 0.744 }
		/>
		<rect
			width={ 7.933 }
			height={ 1.488 }
			x={ 43.629 }
			y={ 61.04 }
			fill="#58707F"
			rx={ 0.744 }
		/>
		<rect
			width={ 9.917 }
			height={ 1.488 }
			x={ 58.504 }
			y={ 61.04 }
			fill="#58707F"
			rx={ 0.744 }
		/>
		<rect
			width={ 9.917 }
			height={ 1.488 }
			x={ 74.867 }
			y={ 61.04 }
			fill="#58707F"
			rx={ 0.744 }
		/>
		<rect
			width={ 8.925 }
			height={ 1.488 }
			x={ 92.221 }
			y={ 61.04 }
			fill="#58707F"
			rx={ 0.744 }
		/>
		<rect
			width={ 0.992 }
			height={ 1.983 }
			x={ 103.762 }
			y={ 60.68 }
			fill="#58707F"
			rx={ 0.496 }
			transform="rotate(20.791 103.762 60.68)"
		/>
		<path
			fill="#58707F"
			fillRule="evenodd"
			d="M9.887 58.163h98.244v.691H9.887v-.691Z"
			clipRule="evenodd"
		/>
		<path fill="#58707F" d="M9.666 50.552h98.244v.692H9.666z" />
		<path fill="#58707F" d="M27.184 42.941h.692v22.14h-.692z" />
		<rect
			width={ 9.917 }
			height={ 1.983 }
			x={ 12.393 }
			y={ 46.413 }
			fill="#58707F"
			rx={ 0.992 }
		/>
		<rect
			width={ 6.942 }
			height={ 1.983 }
			x={ 31.234 }
			y={ 46.413 }
			fill="#58707F"
			rx={ 0.992 }
		/>
		<rect
			width={ 6.942 }
			height={ 1.983 }
			x={ 45.117 }
			y={ 46.413 }
			fill="#58707F"
			rx={ 0.992 }
		/>
		<rect
			width={ 7.933 }
			height={ 1.983 }
			x={ 12.393 }
			y={ 53.85 }
			fill="#58707F"
			rx={ 0.992 }
		/>
		<rect
			width={ 11.9 }
			height={ 1.983 }
			x={ 12.393 }
			y={ 60.792 }
			fill="#58707F"
			rx={ 0.992 }
		/>
		<rect
			width={ 10.908 }
			height={ 1.983 }
			x={ 58.504 }
			y={ 46.413 }
			fill="#58707F"
			rx={ 0.992 }
		/>
		<rect
			width={ 9.917 }
			height={ 1.983 }
			x={ 75.035 }
			y={ 46.413 }
			fill="#58707F"
			rx={ 0.992 }
		/>
		<rect
			width={ 9.917 }
			height={ 1.983 }
			x={ 91.894 }
			y={ 46.413 }
			fill="#58707F"
			rx={ 0.992 }
		/>
	</svg>
);
